import React from "react";

import { templates } from "@reactivated";

import { RetailLocatorSSR } from "../apps/retail-locator/RetailLocatorSSR";

export const Template = (
    props: templates.StearnsRetailLocatorBlockTemplate,
): React.JSX.Element => {
    return <RetailLocatorSSR {...props} />;
};
